"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselFooterButton: function() {
        return _index.TeachingPopoverCarouselFooterButton;
    },
    renderTeachingPopoverCarouselFooterButton_unstable: function() {
        return _index.renderTeachingPopoverCarouselFooterButton_unstable;
    },
    teachingPopoverCarouselFooterButtonClassNames: function() {
        return _index.teachingPopoverCarouselFooterButtonClassNames;
    },
    useTeachingPopoverCarouselFooterButtonStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselFooterButtonStyles_unstable;
    },
    useTeachingPopoverCarouselFooterButton_unstable: function() {
        return _index.useTeachingPopoverCarouselFooterButton_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarouselFooterButton/index");
